import axios from 'axios'
import qs from 'qs'
import constants from '../../../helpers/constants'
import { NOVA_POSHTA_PRICE_LIMIT, NOVA_POSHTA_COURIER_PRICE_LIMIT, UKR_POSHTA_PRICE_LIMIT, COURIER_PRICE_LIMIT, NOVA_POSHTA_POSTOMAT_PRICE_LIMIT } from '@/constants'
import cookieHelper from '@/helpers/cookieHelper'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

const formDataKey = constants.IS_MANAGER_CHECKOUT ? 'formDataManager' : 'formData'

export default {
  state: {
    formData: {
      callback: false
    },
    isDisabledCallback: false, // флаг обязательного перезвона
    isCallbackServiceEnabled: window?.config?.isCallbackEnabledOnCheckout ?? false, // флаг включения/отключения функционала "Перезвонить мне"
    loadingComponents: [],
    errorFromServer: null,
    createOrderInfo: null,
    currentCity: null,
    currency: '',
    isManagerPage: constants.IS_MANAGER_CHECKOUT,
    isManagerLogged: false,
    managersClientData: null,
    managerStoreUid: window?.config?.['manager_store'] ?? '',
    managerStore: localStorage.getItem('managerSelectedStore') ? JSON.parse(localStorage.getItem('managerSelectedStore')) : null
  },
  getters: {
    isCheckoutFormValid (state, getters, rootState) {
      const { formData } = state
      const anyLoadingComponent = Object.keys(state.loadingComponents).reduce((acc, currVal) => {
        if (state.loadingComponents[currVal]) {
          return acc + 1
        }
        return acc
      }, 0) > 1
      // при загрузке форм на чекауте меняется стейт loadingComponents
      // там лежит submitButton всегда true (неизвестно почему и зачем)
      // Потому проверяем, количество загружаемых компонентов на чекауте. Если больше 1 - делаем неактивной кнопку заказа
      return (!anyLoadingComponent && ((formData.paymentType === '3' && getters.isLegalFormValid) ||
        (formData.paymentType && formData.paymentType !== '3')) &&
        getters.isContactFormValid && rootState.paymentForm.paymentTypes.length && getters.isDeliveryFormValid && (!state.isManagerPage || (state.isManagerPage && state.isManagerLogged)))
    },
    currentCityName (state, getters, rootState) {
      return state.currentCity ? state.currentCity[rootState.translation.language] : ''
    },
    totalPrice (state, getters, rootState) {
      const { deliveryType } = state.formData

      const delivery = rootState.contactsForm.deliveryTypes.find(type => type.methodId === deliveryType?.methodId)

      let deliveryCost = delivery?.fullCost ?? 0
      const total = parseInt(rootState.cart.cart.originCost) - parseInt(rootState.bonuses?.bonusesInfoCart?.bonus_debiting || rootState.bonuses.currentBonusValue)
      if (total > NOVA_POSHTA_PRICE_LIMIT && (delivery?.methodId === 3 || delivery?.methodId === 9)) {
        deliveryCost = 0
      }
      if (total > UKR_POSHTA_PRICE_LIMIT && delivery?.methodId === 5) {
        deliveryCost = 0
      }
      if (total > NOVA_POSHTA_COURIER_PRICE_LIMIT && delivery?.methodId === 4) {
        deliveryCost = 0
      }
      if (total > NOVA_POSHTA_POSTOMAT_PRICE_LIMIT && delivery?.methodId === 7) {
        deliveryCost = 0
      }
      if (total > COURIER_PRICE_LIMIT && delivery?.methodId === 2) {
        deliveryCost = 0
      }

      return parseInt(rootState.cart.cart.originCost) + deliveryCost - (state.loadingComponents.bonusesInModal ? 0 : parseInt(rootState.bonuses?.bonusesInfoCart?.bonus_debiting))
    }
  },
  mutations: {
    REDUCE_FORM_DATA (state, data) {
      const formDataFromStorage = JSON.parse(localStorage.getItem(formDataKey))
      const prevData = formDataFromStorage || state.formData
      const reducedFormData = { ...prevData, ...data }
      localStorage.setItem(formDataKey, JSON.stringify(reducedFormData))

      state.formData = reducedFormData
    },
    SET_FORM_DATA_FROM_STORAGE (state) {
      const formDataFromStorage = JSON.parse(localStorage.getItem(formDataKey))
      if (formDataFromStorage) {
        state.formData = { ...formDataFromStorage, prevCallback: formDataFromStorage.callback }
      }
    },
    SET_IS_CONTACT_FORM_VALID (state, bool) {
      state.isContactFormValid = bool
    },
    SET_PAYMENT_FORM_EMPTY (state, bool) {
      state.isPaymentFormEmpty = bool
    },
    SET_LOADING_COMPONENTS (state, data) {
      state.loadingComponents = { ...state.loadingComponents, ...data }

      if (!data) {
        delete state.loadingComponents[Object.keys(data)[0]]
      }
    },
    SET_ERROR_FROM_SERVER (state, data) {
      let error = data
      if (state.errorFromServer === data) {
        if (error[error.length] === ' ') {
          error.substr(0, error.length - 1)
        } else {
          error = error + ' '
        }
      }
      state.errorFromServer = error
    },
    SET_CREATE_ORDER_INFO (state, data) {
      state.createOrderInfo = data
    },
    SET_CURRENCY (state, data) {
      state.currency = data
    },
    SET_IS_MANAGER_LOGGED (state, isLogged) {
      state.isManagerLogged = isLogged
    },
    SET_MANAGERS_CLIENT_DATA (state, data) {
      state.managersClientData = data
    },
    SET_MANAGER_STORE_UID (state, uid) {
      state.managerStoreUid = uid
    },
    SET_MANAGER_STORE (state, data) {
      state.managerStore = data
    },
    SET_IS_DISABLED_CALLBACK_STATUS (state, bool) {
      state.isDisabledCallback = bool
    }
  },
  actions: {
    SET_FORM_DATA (ctx, data) {
      ctx.commit('REDUCE_FORM_DATA', data)
    },
    SET_FORM_DATA_FROM_LOCAL_STORAGE (ctx) {
      ctx.commit('SET_FORM_DATA_FROM_STORAGE')
    },
    VALIDATE_CHECKOUT_FORM ({ commit, state, getters, dispatch }) {
      if (!getters.isContactFormValid) commit('SET_CONTACT_FORM_EMPTY', true)
      else commit('SET_CONTACT_FORM_EMPTY', false)

      if (!getters.isDeliveryFormValid) commit('SET_DELIVERY_FORM_IS_EMPTY', true)

      if (state.formData?.paymentType === '3' && getters.isLegalFormValid) {
        commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', false)
      } else {
        commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', true)
      }

      dispatch('VALIDATE_ANOTHER_RECIPIENT_FORM')
    },
    FETCH_ORDER_INFO ({ commit, state, getters, rootGetters, rootState, dispatch }) {
      try {
        const orderInfo = {
          User: {
            name: state.formData.name,
            last_name: state.formData.lastName,
            father_name: state.formData.fatherName
          },
          CustomerForm: {
            phone: '+380' + state.formData.phone,
            email: state.formData.email
          },
          DeliveryForm: {
            city: state.formData.city.id,
            method: state.formData.deliveryType.methodId
          },
          OrderForm: {
            note: state.formData.note,
            paymentMethod: state.formData.paymentType
          }
        }
        const analyticsCookie = cookieHelper.getCookie('_ga_R2CVLVEMEM')
        const analyticsDataReferrer = sessionStorage.getItem('analyticsDataReferrer') ? JSON.parse(sessionStorage.getItem('analyticsDataReferrer')) : null
        if (!analyticsCookie && analyticsDataReferrer) {
          const itemsData = rootState.cart.products.map(el => GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(el.analytics_data[0]))
          let items = {}
          itemsData.forEach(el => {
            const { promotion_name, promotion_id, creative_slot, item_list_name, item_list_id } = el
            items[el.item_id] = {
              promotion_name, promotion_id, creative_slot, item_list_name, item_list_id
            }
          })
          orderInfo.AnalyticsForm = {
            ...analyticsDataReferrer,
            items
          }
        }
        // Если включен функционал "Перезвонить мне" или обязательный перезвон - добавляем информацию в заказ
        if (state.isCallbackServiceEnabled || state.isDisabledCallback) {
          // Отправляем флаг обратного звонка (все наоборот 0 перезвонить, 1 не перезванивать...)
          orderInfo.OrderForm.callBack = state.formData.callback ? 0 : 1
        } else {
          // тупой костыль!!!!
          orderInfo.OrderForm.callBack = 1
        }

        if (state.isManagerPage) {
          orderInfo.OrderForm.callback = 1
          orderInfo.client_phone = '380' + state.formData.phone

          if (state.formData.logistNote) {
            orderInfo.OrderForm.comment_for_logist = state.formData.logistNote
          }
        }

        if (rootState.deliveryForm.isAnotherRecipient) {
          const { recipientName, recipientFatherName, recipientLastName, recipientPhone } = state.formData
          orderInfo.OrderForm = {
            ...orderInfo.OrderForm,
            another_recipient: true,
            recipientName: recipientName,
            recipientFatherName: recipientFatherName,
            recipientLastName: recipientLastName,
            recipient_phone: '+380' + recipientPhone
          }
        }

        if (rootState.bonuses && rootState.bonuses.bonusesInfoCart && rootState.bonuses.bonusesInfoCart.bonus_debiting) {
          orderInfo.bonuses = +rootState.bonuses.bonusesInfoCart.bonus_debiting
        }

        dispatch('VALIDATE_CHECKOUT_FORM')
        if (state.formData.partsPaymentValue) {
          orderInfo.OrderForm.countPartsPayPart = state.formData.partsPaymentValue
        }

        if (state.formData.deliveryInfo) {
          const { deliveryType, deliveryInfo } = state.formData
          const { methodId } = deliveryType
          const { street, flat: flatNumber, house, deliveryTime } = deliveryInfo

          if (methodId === 1 || methodId === 3 || methodId === 5 || methodId === 7) {
            orderInfo.WarehouseForm = { warehouse: deliveryInfo.deliverySpot.uid }
          } else if (methodId === 4) {
            orderInfo.AddressForm = { street: street.name, house, flatNumber }
          } else if (methodId === 2 || methodId === 6) {
            orderInfo.AddressForm = { street: street.name, house, flatNumber, deliveryDay: deliveryTime.date, deliveryTime: deliveryTime.time }
          }
        }

        if (state.formData.paymentType === '3' && state.formData.legalPersonInfo) {
          const { formId, formRef, full_name: organization, inn, pdv_status, egr, firmEgr, firmTitle, phoneNumberForPayment, documentNdsStatus, shortName } = state.formData.legalPersonInfo
          orderInfo.PaymentForm = {
            organization_type: formRef,
            egrpou: egr,
            organization: organization,
            inn: inn,
            pdv_status: pdv_status ? 1 : 0,
            document_nds_status: documentNdsStatus
          }
          if (firmEgr) {
            orderInfo.PaymentForm.firmEgr = firmEgr
          }
          if (firmTitle) {
            orderInfo.PaymentForm.firmTitle = firmTitle
          }
          if (shortName) {
            orderInfo.PaymentForm.shortName = shortName
          }

          if (formId === 'd558bfcc-7456-11df-ad52-000c29118aa7') {
            orderInfo.PaymentForm.egrpou = inn
          } else if (documentNdsStatus === '1' && !egr && inn) {
            orderInfo.PaymentForm.egrpou = inn
          }

          if (state.isManagerPage) {
            if (phoneNumberForPayment) {
              orderInfo.phone_number_for_payment = '380' + phoneNumberForPayment.value
            }
          }
        }

        if (getters.isCheckoutFormValid) {
          commit('SET_LOADING_COMPONENTS', { totalPrice: true })

          return new Promise((resolve, reject) => {
            axios.post(rootGetters.urlLanguagePrefix + '/shop/checkout/create-order/', qs.stringify({ order: orderInfo }), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': 'application/json, text/javascript, */*; q=0.01'
              }
            }).then(response => {
              const { order } = response.data
              commit('SET_CREATE_ORDER_INFO', response.data)

              if (order && !order.status && order.error_message) {
                // При ошибке обновляем способы доставки
                dispatch('FETCH_DELIVERY_TYPES', state.formData.city.id)
                commit('SET_ERROR_FROM_SERVER', order.error_message)
              } else if (order && order.status) {
                localStorage.removeItem(formDataKey)
                dispatch('REMOVE_BONUSES_INFO_FROM_LOCAL_STORAGE')
              }
              resolve(order)
            })
              .catch(error => reject(error))
          })
        }
      } catch (e) {
        commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error'))
      }
    },
    SET_IS_CONTACT_FORM_VALID_ACTION (ctx, bool) {
      ctx.commit('SET_IS_CONTACT_FORM_VALID', bool)
    },
    SET_LOADING_COMPONENT (ctx, data) {
      ctx.commit('SET_LOADING_COMPONENTS', data)
    },
    SET_IS_DISABLED_CALLBACK_STATUS_ACTION ({ commit }, bool) {
      commit('SET_IS_DISABLED_CALLBACK_STATUS', bool)
    },
    SET_IS_MANAGER_LOGGED ({ commit }, isLogged) {
      commit('SET_IS_MANAGER_LOGGED', isLogged)
    },
    SET_MANAGERS_CLIENT_DATA_ACTION ({ commit }, data) {
      commit('SET_MANAGERS_CLIENT_DATA', data)
    },
    SET_MANAGER_STORE_ACTION ({ rootGetters, commit }, store) {
      return new Promise((resolve, reject) => {
        axios.post(rootGetters.urlLanguagePrefix + '/manager-checkout/set-manager-store/', qs.stringify({ store_uid: store.uid }))
          .then(res => {
            commit('SET_MANAGER_STORE_UID', store.uid)
            commit('SET_MANAGER_STORE', store)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
